const Endpoints = {
  Auth: {
    AppRedirectLogin: '/api/auth/web-redirect-login',
  },
  Query: {
    GetAssets: '',
    GetChains: '/api/chain/get-all',
    GetMerchantList: '/api/merchant/get-all',
    GetAssetInfos: '/api/asset-info-by-addr',
  },
  TransactionRequest: {
    GetAll: '/api/request-approval/get-all',
    Export: '/api/request-approval/export',
    GetAllV2: '/api/transaction-request/get-all',
    ExportV2: '/api/transaction-request/export',
    TransactionOperations: '/api/transaction-operation/get-all',
    GetApprovalHistory: '/api/request-approval/get-approval-list',
    Approve: '/api/request-approval/approve',
    Reject: '/api/request-approval/reject',
    SignApprove: '/api/request-approval/upload-signatures',
  },
} as const;

export default Endpoints;
